import React from 'react';

import Link from 'next/link';

import { H5 } from '@repo/ui-kit/components/core/Typography';

import { LinkText } from './styles';
import { LinkProps } from './types';

export const Label: React.FC<LinkProps> = ({ url, label, activeStyle }) => {
  const text = (
    <LinkText activeStyle={!!activeStyle}>
      <H5 color="inherit">{label}</H5>
    </LinkText>
  );

  if (url) {
    return <Link href={url}>{text}</Link>;
  }

  return text;
};
